import { Fragment } from "react";

import { Outlet } from "react-router-dom";

import Header from "./header.jsx";
import Footer from "./footer.jsx";
import ErrorBoundary from "../utils/erro/ErrorBoundary.jsx";

export default function LayoutPadrao({ sessaoUsuario }) {
  return (
    <Fragment>
      <Header sessaoUsuario={sessaoUsuario} />
      <ErrorBoundary>
        <Outlet />
        {/* Apresentação da tela */}
      </ErrorBoundary>
      <br />
      <br />
      <Footer sessaoUsuario={sessaoUsuario} />
    </Fragment>
  );
}
